import { AsyncPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalleryAccessLevel, GalleryDto } from '@picflow/types';
import { getAnonymousGuestName } from 'src/app/lib/get-anonymous-guest-name';
import { BrowserService } from 'src/app/services/browser.service';
import { DialogService } from 'src/app/services/dialog.service';
import { GuestAuthService } from 'src/app/services/guest-auth.service';
import { StateService } from 'src/app/services/state.service';
import { ToastService } from 'src/app/services/toast.service';
import { AvatarPipe } from '../../../shared-extra/pipes/avatar.pipe';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { GuestProfileDialogComponent } from '../../dialogs/guest-profile-dialog/guest-profile-dialog.component';

@Component({
  selector: 'app-view-profile-menu',
  templateUrl: './view-profile-menu.component.html',
  styleUrls: ['./view-profile-menu.component.scss'],
  standalone: true,
  imports: [NgIf, ButtonDirective, SvgComponent, ButtonMenuItemComponent, AsyncPipe, AvatarPipe, AvatarComponent],
})
export class ViewProfileMenuComponent {
  @Input() accessLevel: GalleryAccessLevel;
  @Input() gallery: GalleryDto;
  @Output() onClose = new EventEmitter();
  picflowUrl: string;
  anonymousGuestName: string;

  constructor(
    public state: StateService,
    private guestAuth: GuestAuthService,
    private toasts: ToastService,
    private browserService: BrowserService,
    private dialog: DialogService
  ) {
    if (this.state.preGuestAnonymousId) {
      this.anonymousGuestName = getAnonymousGuestName(this.state.preGuestAnonymousId);
    }
    this.picflowUrl = this.browserService.getCorrectPicflowUrl();
  }

  async openGuestProfileDialog() {
    await this.dialog.open(GuestProfileDialogComponent, { gallery: this.gallery });
  }

  logout() {
    this.guestAuth.logout();
    this.toasts.add('You are now logged out.', 'success');
  }

  getSignupUrl() {
    if (this.state.guest?.email) {
      return `${this.picflowUrl}/auth/signup?email=${encodeURIComponent(this.state.guest.email)}`;
    }
    return `${this.picflowUrl}/auth/signup`;
  }
}
